import React, { useEffect, useRef, useState } from 'react'
import style from './index.module.scss'
import { message, Button } from 'antd';
import useStore from '../../store/useStore'
import { createDis, getDisInfo, postDisContent } from '../../api/discussion';
import close from './close.png';
import { memosModule } from '../../modules/memos';
import { StorageModule } from '../../modules/storage';
import TextArea from 'antd/lib/input/TextArea';

interface Props {
    visible: boolean;
    onClose: () => void;
}

const CreatePop = (props: Props) => {
    const [content, setcontent] = useState<string>('');
    const { store, dispatch } = useStore();

    const titleRef = useRef<any>();
    useEffect(() => {
        if (props.visible) {
            setTimeout(() => {
                titleRef && titleRef.current.focus({
                    cursor: 'end',
                });
            }, 500);
        }
    }, [titleRef])

    // 获取聊天基本信息
    const confirm = async () => {
        if (!content) {
            message.error('请填写内容');
            return '';
        }
        const dis = await createDis(store.chatId);
        const discussionId = dis?.data;
        const discussionres = await getDisInfo(store.chatId, discussionId);
        const discussion = discussionres?.data;
        await postDisContent(store.chatId, discussionId, {
            "id": discussion.chatId,
            "memoId": discussion.memoId,
            "discussionId": discussion.id,
            "content": content,
            'topicId': store.subjectInfo.subjectId
        });
        (window as any).graphItem.getCellById(store.chatId).setData({
            data: {
                discussionId: discussionId
            }
        })
        closepop();
    }
    // /**
    //  * 主题详情
    //  */
    // const getDetail = async () => {
    //     if (store.subjectInfo.subjectId) {
    //         await memosModule.getDetail(store.subjectInfo.subjectId)
    //     } else {
    //         let user: any = StorageModule.getUser().user
    //         let id: any = user?.attachInfo?.userTopicDesktop?.rootTopicId
    //         if (id) {
    //             await memosModule.getDetail(store.subjectInfo.subjectId)
    //         }
    //     }
    //     dispatch({
    //         type: 'SET_RERENDERCOUNT',
    //         data: store.rerenderCount + 1
    //     })
    // }
    const closepop = () => {
        dispatch({
            type: 'SET_CHATDISCUSSIONID',
            data: ''
        });
        dispatch({
            type: 'SET_CHATID',
            data: ''
        });
        dispatch({
            type: 'SET_SHOWCREATECHAT',
            data: false
        });
    }

    const render = (
        <>{props.visible && <div className={style.create}>
            <div className={style.createcontent}>
                <div className={style.createtitle}>
                    <div className={style.createname}>
                        讨论
                    </div>
                    <img className={style.createclose}
                        src={close}
                        onClick={() => {
                            closepop();
                        }}
                    />
                </div>
                <TextArea className={style.createinput}
                    ref={titleRef}
                    value={content}
                    placeholder="请发表你的观点"
                    onInput={(e: any) => {
                        setcontent(e?.target?.value || '');
                    }}>
                </TextArea>
                <Button
                    disabled={content.length === 0}
                    className={style.createbtn + ' ' + (content.length === 0 ? style.disable : '')}
                    type='primary'
                    size='small'
                    onClick={confirm}>
                    发布观点
                </Button>
            </div>
        </div>}</>
    )

    return render
}

export default CreatePop;
